import React from "react";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import { Checkbox, TableHead, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";
import ShipmentRegion from "../../HOC/CustomComponents/ShipmentRegion";
import { FixedTableCell } from "../../HOC/CustomComponents/FixedTableCell";

const PREFIX = "ShipmentListDetails";

const classes = {
  shipmentTable_checkbox: `${PREFIX}-shipmentTable_checkbox`,
};

const StyledTableHead = styled(TableHead)(({ theme }) => ({
  [`& .${classes.shipmentTable_checkbox}`]: {
    zIndex: "100",
    backgroundColor: "#fff",
    position: "sticky",
    top: 0,
    left: 0,
  },
}));

export const invoiceShipmentsCells = (shipmentDetails) => {
  const cells = (
    <>
      <FixedTableCell>{shipmentDetails?.status?.name}</FixedTableCell>
      <FixedTableCell>{shipmentDetails?.date}</FixedTableCell>
      <FixedTableCell>{shipmentDetails?.deliveredCanceledDate}</FixedTableCell>
      <FixedTableCell>{shipmentDetails?.recipientName}</FixedTableCell>
      <ShipmentRegion
        pathname={`/admin/zone/${shipmentDetails?.recipientZone?.id}`}
        zone={shipmentDetails?.recipientZone?.name}
        subzone={shipmentDetails?.recipientSubzone?.name}
      />
      <FixedTableCell>
        {shipmentDetails?.deliveryFees + shipmentDetails?.extraWeightFees}
      </FixedTableCell>
      <FixedTableCell>{shipmentDetails?.postFees}</FixedTableCell>
      <FixedTableCell>{shipmentDetails?.tax}</FixedTableCell>
      <FixedTableCell>{shipmentDetails?.returningDueFees}</FixedTableCell>
    </>
  );

  return cells;
};
export function EnhancedTableHead(props) {
  const { onSelectAllClick, numSelected, rowCount } = props;
  const { t } = useTranslation();

  const headCells = [
    t("requestCode"),
    t("shipmentStatus"),
    t("date"),
    t("deliveryCanclingDate"),
    t("recipient"),
    t("destination"),
    t("deliveryFees"),
    t("postFees"),
    t("tax"),
    t("returningDueFees"),
  ];

  return (
    <StyledTableHead>
      <TableRow>
        <FixedTableCell
          className={classes.shipmentTable_checkbox}
          padding="checkbox"
        >
          <Checkbox
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{ "aria-label": "select all desserts" }}
          />
        </FixedTableCell>
        {headCells.map((headCell, index) => (
          <FixedTableCell key={index}>{headCell}</FixedTableCell>
        ))}
      </TableRow>
    </StyledTableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  rowCount: PropTypes.number.isRequired,
};
